import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pdp: {
    pdpBuyBoxMode: null, // this will be set in getServerSideProps
    selectedSizeSku: null,
    secondSelectedSizeSku: null,
    reviewModal: {
      isOpen: false,
      index: 0,
      reviewId: null,
    },
    tabSelected: "Product Details",
    sizeMappings: [],
    fitNotes: null,
    sizeGuideModalOpen: false,
  },
};

const pdpSlice = createSlice({
  initialState,
  name: "pdp",
  reducers: {
    setSelectedSizeSku(state, action) {
      if (!state.pdp) state.pdp = {};
      state.pdp.selectedSizeSku = action.payload;
    },
    setSecondSelectedSizeSku(state, action) {
      if (!state.pdp) state.pdp = {};
      state.pdp.secondSelectedSizeSku = action.payload;
    },
    setPDPBuyBoxMode(state, action) {
      if (!state.pdp) state.pdp = {};
      state.pdp.pdpBuyBoxMode = action.payload;
    },
    setReviewModalOpen(state, action) {
      if (!state.pdp) state.pdp = {};
      if (!state.pdp.reviewModal) state.pdp.reviewModal = { isOpen: false, index: 0, reviewId: null };
      state.pdp.reviewModal.isOpen = action.payload;
      if (action.payload === false) {
        state.pdp.reviewModal.index = 0;
        state.pdp.reviewModal.reviewId = null;
      }
    },
    setReviewModalIndex(state, action) {
      if (!state.pdp) state.pdp = {};
      if (!state.pdp.reviewModal) state.pdp.reviewModal = { isOpen: false, index: 0, reviewId: null };
      state.pdp.reviewModal.index = action.payload;
    },
    setReviewModalReviewId(state, action) {
      if (!state.pdp) state.pdp = {};
      if (!state.pdp.reviewModal) state.pdp.reviewModal = { isOpen: false, index: 0, reviewId: null };
      state.pdp.reviewModal.reviewId = action.payload;
    },
    setTabSelected(state, action) {
      if (!state.pdp) state.pdp = {};
      state.pdp.tabSelected = action.payload;
    },
    setSizeMappings(state, action) {
      if (!state.pdp) state.pdp = {};
      state.pdp.sizeMappings = action.payload;
    },
    setSizeGuideModalOpen(state, action) {
      if (!state.pdp) state.pdp = {};
      state.pdp.sizeGuideModalOpen = action.payload;
    },
    setFitNotes(state, action) {
      if (!state.pdp) state.pdp = {};
      state.pdp.fitNotes = action.payload;
    },
  },
});

export const {
  setSelectedSizeSku,
  setSecondSelectedSizeSku,
  setPDPBuyBoxMode,
  setReviewModalOpen,
  setReviewModalIndex,
  setReviewModalReviewId,
  setTabSelected,
  setSizeMappings,
  setSizeGuideModalOpen,
  setFitNotes,
} = pdpSlice.actions;
export const types = [
  "pdp/setSelectedSizeSku",
  "pdp/setSecondSelectedSizeSku",
  "pdp/setPDPBuyBoxMode",
  "pdp/setReviewModalOpen",
  "pdp/setReviewModalIndex",
  "pdp/setReviewModalReviewId",
  "pdp/setTabSelected",
  "pdp/setSizeMappings",
  "pdp/setSizeGuideModalOpen",
  "pdp/setFitNotes",
];

export default {
  types: types,
  fn: pdpSlice.reducer,
};
